<!-- 商品供应商-侧边菜单 -->
<template>
  <div :class="['side-bar-menu', { close: !open }]">
    <span
      :class="[
        'menu-toggle-button mtdicon mtdicon-left-thick',
        { close: !open },
      ]"
      @click="toggleFold"
    ></span>

    <div :class="['menu-container', { close: !open }]">
      <mtd-menu
        v-model="activeMenu"
        mode="inline"
        accordion
        :default-expanded-names="expandedSubMenusNames"
        @select="handleSelectMenu"
      >
        <template v-for="item in menuData">
          <template v-if="firstLevelMenuShow(item)">
            <mtd-submenu
              v-if="item.children && item.children.length"
              :key="item.id"
              :name="item.id"
              :class="['custom-sub-menu']"
              :icon="getMenuIcon(item)"
            >
              <template #title>
                <div class="first-level-title">{{ item.textMultiLocale }}</div>
              </template>
              <template v-for="(childItem, childIndex) in item.children">
                <mtd-menu-item
                  v-if="subMenuShow(childItem)"
                  :key="childIndex"
                  :name="childItem.id"
                >
                  <span
                    :class="[
                      'second-level-menu-title',
                      isCurrentMenuItem(childItem) ? 'active-title' : '',
                    ]"
                  >
                    {{ childItem.textMultiLocale }}
                  </span>
                </mtd-menu-item>
              </template>
            </mtd-submenu>

            <mtd-menu-item
              v-else
              :name="item.id"
              :key="item.id + 'level'"
              :icon="getMenuIcon(item)"
            >
              <span
                :class="[
                  'first-level-menu-title',
                  isCurrentMenuItem(item) ? 'active-title' : '',
                ]"
              >
                {{ item.textMultiLocale }}
              </span>
            </mtd-menu-item>
          </template>
        </template>
      </mtd-menu>
    </div>
  </div>
</template>
<script>
import { findBestMatchUrl } from "@/utils/menu";

export default {
  name: "AsideMenu",
  inject: ['$xxMenu'],
  data() {
    return {
      open: true,
      activeMenu: "",
      expandedSubMenusNames: [],
      currentPath: window.location.pathname,
    };
  },
  computed: {
    menuData(){
      return this.$xxMenu.menuData;
    }
  },
  mounted() {
    if (localStorage.getItem("openSidebar") === "false") {
      this.open = false;
      this.$emit("toggleEvent", false);
    }
  },
  watch: {
    menuData: {
      handler(menuList) {
        this.handleSupplierMenuListChange(menuList);
      },
      immediate: true,
    },
  },
  methods: {
    toggleFold() {
      this.open = !this.open;
      localStorage.setItem("openSidebar", this.open);
      this.$emit("toggleEvent", this.open);
    },

    handleSupplierMenuListChange(menuList) {
      if (localStorage.getItem("openSidebar") === "false") {
        this.open = false;
        this.$emit("toggleEvent", false);
      }

      this.setMenuExpandedAndActiveItem(this.menuData, menuList);
      this.setScrollTop();
    },

    subMenuShow(subMenuItem) {
      return subMenuItem.visible && subMenuItem.value;
    },

    firstLevelMenuShow(menuItem) {
      if (!menuItem.visible) {
        return false;
      }

      if (menuItem.children && menuItem.children.length) {
        return menuItem.children.find((item) => item.value === 1);
      } else {
        return menuItem.value && menuItem.url;
      }
    },

    getMenuIcon(data) {
      const menuCodeMap = {
        Home: "10223",
        SupplyCollaboration: "10224",
      };
      const _map = {
        [menuCodeMap.Home]: "mtdicon-home-o",
        商品信息: "mtdicon-cart-o",
        资质管理: "mtdicon-file",
        报价管理: "mtdicon-database-o",
        [menuCodeMap.SupplyCollaboration]: "mtdicon-avatar-group",
        电子合同: "mtdicon-printing",
        结算管理: "mtdicon-bankcard",
        融资管理: "mtdicon-bank-card-fill",
        商信息: "mtdicon-contacts",
        商数据: "mtdicon-areachart-o",
        周转物资管理: "mtdicon-theme-o",
        营销管理: "mtdicon-invoice-o",
      };
      if (_map[data.code]) {
        return _map[data.code];
      } else {
        return "mtdicon-menus-o";
      }
    },

    isCurrentMenuItem(item) {
      const path = this.currentPath.replace(".html", "");
      if (path === item.url) {
        return true;
      }

      if (
        (path === "/" || path === "/partner/index") &&
        (item.url === "/" || item.url === "/partner/index")
      ) {
        return true;
      }

      return false;
    },

    findItemByProp(nestedMenuList, prop, target) {
      for (const item of nestedMenuList) {
        if (item[prop] === target) {
          return item;
        }
        const indexPath = ["/", "/partner/index"];
        if (
          prop === "url" &&
          indexPath.includes(target) &&
          indexPath.includes(item[prop])
        ) {
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = this.findItemByProp(item.children, prop, target);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },

    findMenuByPath(menuList, id) {
      for (const menu of menuList) {
        if (menu.id === id) {
          return menu;
        }
        if (menu.children) {
          const targetChild = menu.children.find((child) => child.id === id);
          if (targetChild) {
            return targetChild;
          }
        }
      }
      return {};
    },

    async handleSelectMenu(item) {
        const menu = this.findItemByProp(this.menuData, "id", item.name);
        this.$xxMenu.linkTo(menu);
    },

    async setScrollTop() {
      await this.$nextTick();
      const _container = document.querySelector(".menu-container");
      const _target =
        document.querySelector(".menu-item.active-title") ||
        document.querySelector(".solo-menu-link.active-title");
      if (_container && _target) {
        _container.scrollTop =
          _container.scrollTop + _target.getClientRects()[0].top - 120;
      }
    },

    setMenuExpandedAndActiveItem(treeMenuList, menuListArr) {
      const path = this.currentPath.replace(".html", "");
      const menu = this.findItemByProp(treeMenuList, "url", path);
      if (menu) {
        this.activeMenu = menu.id;
        this.expandedSubMenusNames = [menu.parent];
      } else {
        const bestMatchUrl = findBestMatchUrl(path, menuListArr);
        if (bestMatchUrl) {
          this.activeMenu = bestMatchUrl.id;
          this.expandedSubMenusNames = [bestMatchUrl.parent];
        }
      }
    },
  },
};
</script>

<style scoped>
.first-level-menu-title {
  font-weight: 500;
  color: #191919;
}

.second-level-menu-title {
  font-size: 14px;
  line-height: 22px;
  color: #111925;
}

.active-title {
  color: #01a65c;
}

.custom-sub-menu {
  margin-block-start: 16px;
}

:deep() .mtd-menu-item-active .mtd-submenu-icon {
  color: #00b85c;
}

:deep() .mtd-submenu-expanded .mtd-submenu-icon {
  color: #00b85c;
}

:deep() .mtd-submenu-expanded .first-level-title {
  color: #01a65c;
}

:deep() .mtd-submenu ul.mtd-submenu-content {
  margin-block-start: 8px;
}

:deep() .mtd-submenu ul.mtd-submenu-content li:not(:last-child) {
  margin-block-end: 16px;
}

:deep() .mtd-submenu .mtd-menu-item-text {
  background: #fff;
  padding: 8px;
  line-height: 22px;
  border-radius: 8px;
}

:deep() .mtd-submenu .mtd-menu-item-active .mtd-menu-item-text {
  background: #e5f7ee;
}

:deep() .mtd-menu-item-active:before {
  background: #fff !important;
}

:deep() .mtd-menu-item-title {
  background: #fff !important;
}

:deep() .mtd-menu {
  line-height: 48px;
}

:deep() .mtd-submenu-title:hover .mtd-submenu-direction {
  color: #00b85c !important;
}

.menu-dot-num {
  position: absolute;
  top: -4px;
  right: 0px;
  background-color: red;
  border-radius: 99px;
  color: #fff;
  font-size: 12px;
  transform: scale(0.8);
  min-width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  padding: 0px 2px;
}
.side-bar-menu {
  width: 316px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  transition: all 0.2s;
  position: relative;
}
.side-bar-menu.close {
  width: 20px;
}

.menu-container {
  overflow: auto;
  padding: 12px 0 0 0;
  transition: all 0.2s;
}
.menu-container.close {
  transform: translateX(-180px);
  opacity: 0;
}

:root[dir="rtl"] .menu-container.close {
  transform: translateX(180px);
  opacity: 0;
}

.list-box {
  padding: 0 0 60px 0;
}

.side-bar-menu-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.side-bar-menu-bottom {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  z-index: 1;
  /* height: 40px; */
  line-height: 20px;
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: rgba(0, 0, 0, 0.917647) 0 21px 20px 0,
    rgba(0, 0, 0, 0.3157) 0 0 15px 0;
}
.side-bar-menu-bottom .side-bar-fold {
  display: flex;
  width: 40px;
  /* height: 40px; */
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.side-bar-menu-bottom .side-bar-fold.close {
  width: 50px;
}

.menu-toggle-button {
  position: absolute;
  top: 24px;
  right: -10px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(17, 25, 37, 0.1);
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  border-radius: 99px;
  z-index: 999;
  transition: all 0.2s;
}

:root[dir="rtl"] .menu-toggle-button {
  left: -10px;
  right: auto;
}

.menu-toggle-button:hover {
  transform: scale(1.1);
}
.menu-toggle-button.close {
  transform: rotate(180deg);
}

:root[dir="rtl"] .menu-toggle-button.close {
  transform: rotate(360deg);
}
:root[dir="rtl"] .menu-toggle-button {
  transform: rotate(180deg);
}

:root[dir="rtl"] .menu-container :deep(.mtd-menu-item-text) {
  text-align: right !important;
}
:root[dir="rtl"] .menu-container :deep(.mtd-submenu-text) {
  text-align: right !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-submenu-icon) {
  margin-right: 0;
  margin-left: 8px !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-menu-item-icon) {
  margin-right: 0;
  margin-left: 8px !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-submenu-direction) {
  margin-left: 0;
  margin-right: 12px;
}

.menu-box {
  padding: 0px 16px 20px 16px;
}
.menu-parent,
.solo-menu-link {
  font-size: 18px;
  color: #191919;
  line-height: 26px;
  font-weight: 500;
  padding: 0 0 0 5px;
  text-decoration: none;
}
.solo-menu-link:hover {
  cursor: pointer;
}
.solo-menu-link.current {
  color: #01a65c;
}
.menu-parent:has(+ .menu-item-container .current) {
  color: #01a65c;
}
.menu-item-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 14px 0 0 0;
  position: relative;
}
.aside-menu-icon {
  margin-right: 5px;
}
.menu-item {
  color: #666666;
  text-decoration: none;
  width: 50%;
  margin-bottom: 6px;
  font-size: 14px;
  padding: 4px 4px 4px 7px;
  border-radius: 4px;
  position: relative;
}

.menu-item:hover {
  color: #666666;
  background-color: #f8f8f8;
  cursor: pointer;
}

.menu-item.current {
  background: #e5f7ee;
  color: #00b85c;
  font-weight: 600;
}

.menu-item .full-text {
  display: none;
}

.menu-item:hover .full-text {
  display: block;
}
.menu-text {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
.full-text {
  display: none;
  position: absolute;
  top: -33px;
  right: 0px;
  padding: 6px 10px;
  background: #292929;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
}
.full-text::before {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50px;
  border-top: 5px solid #292929;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 0px;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #dcdddf;
}
</style>
